import styled from '@emotion/styled';

export const Spacer = styled.div`
  flex: 1;
`;
